import http from '@/biz/http.mjs'
import {useChooseProject} from '@/biz/project'
import runAsync from '@/script/runAsync.mjs'
import {useMapContext} from '@/components/MindMap/index.mjs'
import parseMap from '../../../scripts/parseMap.mjs'

const useMenuItemCompleteRef = ({mapProp, mapType, url}) => {
    const chooseProject = useChooseProject({
        allowChooseNone: true,
        multiple: true,
    })

    const map = useMapContext()
    const permission = map.usePermission()
    const {mapTypeCode, prjId, sVer} = map.data

    if (! (
        mapType === mapTypeCode &&
        permission.has('write')
    )) {
        return null
    }

    const onClick = async () => {
        const projects = await chooseProject()

        if (! projects) {
            return
        }

        const prjs = projects.map(
            ({pkid, sVer}) => ({pkid, sVer})
        )

        const {pkid: dpId} = map.root.data

        const {[mapProp]: mapJson, ...data} = await runAsync(
            () => http.post(url, {dpId, prjId, prjs, sVer}),
            {action: '补全模件链接'}
        )

        const {root} = parseMap(mapJson)

        map.execute(() => {
            const _n = map.nodeProxy(map.root)
            _n.replace(root)
            map.root.data = {...map.root.data, ...data}
        })
    }

    return {
        key: 'complete-ref',
        label: '补全模件链接',
        onClick,
    }
}

export const useMenuItemCompleteRefBd = () => {
    return useMenuItemCompleteRef({
        mapProp: 'bdMap',
        mapType: '_BD_MAP',
        url: '/dpRefComplete/completeRefBd',
    })
}

export const useMenuItemCompleteRefUi = () => {
    return useMenuItemCompleteRef({
        mapProp: 'uiMap',
        mapType: '_UI_MAP',
        url: '/dpRefComplete/completeRefUi',
    })
}
